import Vue from 'vue'
import Vuex from 'vuex'

import Status from './status'
Vue.use(Vuex)


const store = new Vuex.Store({
	modules: {
		status:Status
	}
})
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js